import axios from "axios";

export const timeExpireToken = 5;

export const getlocalStorageLogin = () => {
  const cookieName = "admin=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      const cookieValue = cookie.substring(cookieName.length, cookie.length);
      try {
        const decodedValue = decodeURIComponent(cookieValue);
        return JSON.parse(decodedValue);
      } catch (error) {
        console.error("Error parsing cookie value:", error);
        // Handle the error appropriately, such as returning null or an empty object
        return null;
      }
    }
  }
  return null;
};

export const getTimeActiveToken = () => {
  let DataLocalStorageUser = getlocalStorageLogin();

  if (!DataLocalStorageUser) {
    return null;
  }

  let timeLogin = new Date(DataLocalStorageUser.startTime);
  let timeCurrent = new Date();
  let timeDiffMillSecound = Math.abs(timeCurrent - timeLogin);
  return timeDiffMillSecound / 1000 / 60;
};

const isExpire = () => {
  const timeDifMin = getTimeActiveToken();

  if (!timeDifMin) {
    return null;
  }

  // if (timeDifMin > timeExpireToken && pathname !== "/auth") {
  //   dispatch({
  //     type: actionTypesNotif.error,
  //     textAlert: "زمان ورود شما به پایان رسید، لطفا دوباره لاگین کنید.",
  //   });

  //   dispatch({
  //     type: actionTypesNotif.flagExpire,
  //     payload: true,
  //   });

  //   setTimeout(() => {
  //     window.location.assign("/auth");
  //     sessionStorage.setItem("redirectpath", window.location.pathname);
  //   }, 3000);

  //   return null;
  // }

  return getlocalStorageLogin();
};

const AxiosCustom = async (_config, _data) => {
  const adminObj = getlocalStorageLogin();

  let tokenStr = adminObj ? isExpire() : null;
  let memberidStr = tokenStr ? tokenStr.authMemberId : null;

  let token = tokenStr ? tokenStr.authToken : null;
  let member_id = memberidStr ? memberidStr : null;
  let config = {
    baseURL: getUrl(),
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },

    ..._config,
    data: {
      api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
      token: token,
      member_id: member_id,
      ..._data,
      // table: "",
      // method_type: "login",
      // data: {
      //     "user": "ERFAN",
      //     "pass": "ERF1234"
      // }
    },
  };
  return await axios(config);
};

export function getUrl() {
  let protocol = window.location.protocol;
  let hostName = window.location.hostname;

  if (!protocol || !hostName || hostName === "localhost") {
    // return "http://172.16.39.104:7001/GradDB/V1";
    // return "http://172.16.39.106:8000/GradDB/V1";
    return `https://my.pishrobroker.ir/GradDB/V1`;
  }

  return `${protocol}//${hostName}/GradDB/V1/`;
}

export default AxiosCustom;
